import { UserStore } from './user.type';

export const ACTION_USER_NOT_AUTHORIZED_SET = 'ACTION_USER_NOT_AUTHORIZED_SET';

export const USER_STORE_INITIAL_STATE: UserStore = {};
